import cx from 'clsx';
import { useUiStateMatches } from '@/core';
import type { KnapsackNavItem } from '@knapsack/types';
import { DnDNavTree, type NavItem } from '@knapsack/toby'; // @todo: should this type be in @knapsack/types?
import { NavTreeItem } from './nav-tree-item';

type Props = {
  activeNavItem: KnapsackNavItem;
  canEdit?: boolean;
  handleNewTreeItems?: (newNavItems: NavItem[]) => void;
  ariaLabel: string;
  treeItems: NavItem[];
};

export const NavTree = ({
  activeNavItem,
  canEdit,
  handleNewTreeItems,
  ariaLabel,
  treeItems,
}: Props) => {
  const classes = cx('ks-secondary-nav', 'ks-test-secondary-nav');
  const isEditingNav = useUiStateMatches('navEdit.editing');

  if (!treeItems) return null;

  return (
    <nav className={classes} aria-label={ariaLabel}>
      <div className="rst__tree">
        <DnDNavTree
          items={treeItems}
          activeNavItem={activeNavItem}
          onItemsChange={handleNewTreeItems}
          isDraggable={canEdit && !isEditingNav && treeItems.length > 0}
        >
          {({ flattenedItems, treeState }) => {
            return flattenedItems.map(({ item, depth }) => (
              <NavTreeItem
                key={item.id}
                canEdit={canEdit}
                isActive={treeState.isItemActive(item.id)}
                node={item}
                isExpanded={treeState.isItemExpanded(item.id)}
                onToggleExpanded={treeState.toggleExpanded}
                depth={depth}
              />
            ));
          }}
        </DnDNavTree>
      </div>
    </nav>
  );
};

export default NavTree;
